import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WowInit from "../../components/wowInit/wowInit";

// ✅ Home Pages
import Homepage from "../HomePage";
import HomePage2 from "../HomePage2/HomePage2";
import HomePage3 from "../HomePage3/HomePage3";
import AboutPage from "../AboutPage/AboutPage";
import ServicePage from "../ServicePage/ServicePage";
import SeviceSinglePage from "../SeviceSinglePage/SeviceSinglePage";
import CareerSection from "../CareerSection/CareerSection";
import CareerDetails from "../CareerDetails/CareerDetails";
import ProjectPage from "../ProjectPage/ProjectPage";
import ProjectDetails from "../ProjectDetails/ProjectDetails";
import TeamPage from "../TeamPage/TeamPage";
import ScrollToTop from "./ScrollToTop";
import BlogPage from "../BlogPage/BlogPage";
import BlogDetails from "../BlogDetails/BlogDetails";
import ContactPage from "../ContactPage/ContactPage";
import ErrorPage from "../ErrorPage/ErrorPage";

//MegaPages
import MegaPage3 from "../../components/Header/MegaPage3"
import MegaPage4 from "../../components/Header/MegaPage4"
import MegaPage5 from "../../components/Header/MegaPage5"
import MegaPage6 from "../../components/Header/MegaPage6"
import MegaPage7 from "../../components/Header/MegaPage7"



// Service Detail pages 
import BusinessConsulting from "../ServiceDetails/BusinessConsulting";
import WebDevelopment from "../ServiceDetails/webapp/WebDevelopment";
import AppDevelopment from "../ServiceDetails/webapp/AppDevelopment";
import BrandDevelopment from "../ServiceDetails/Brand/BrandDevelopment";

// Brand Development Service Pages
import LogoDesign from "../ServiceDetails/Brand/LogoDesign";
import BrandIdentity from "../ServiceDetails/Brand/BrandIdentity";
import UIUXDesign from "../ServiceDetails/Brand/UIUXDesign";
import MarketingCreatives from "../ServiceDetails/Brand/MarketingCreatives";
import SocialMediaBranding from "../ServiceDetails/Brand/SocialMediaBranding";
import ReputationManagement from "../ServiceDetails/Brand/ReputationManagement";

// Web & App Development Service Pages
import WebsitePortals from "../ServiceDetails/webapp/WebsitePortals";
import SaasPlatforms from "../ServiceDetails/webapp/SaasPlatforms";
import CMSDevelopment from "../ServiceDetails/webapp/CMSDevelopment";
import EcommercePlatforms from "../ServiceDetails/webapp/EcommercePlatforms";
import AndroidApps from "../ServiceDetails/webapp/AndroidApps";
import IOSApps from "../ServiceDetails/webapp/iOSApps";
import HybridApps from "../ServiceDetails/webapp/HybridApps";
import Web3Apps from "../ServiceDetails/webapp/Web3Apps";
import OnDemandApps from "../ServiceDetails/webapp/OnDemandApps";
import EnterpriseApps from "../ServiceDetails/webapp/EnterpriseApps";
import CryptoExchangeService from "../ServiceDetails/CryptoExchangeService";
import NftMarketplace from "../ServiceDetails/NftMarketplaceService"
import Development from "../ServiceDetails/web3.0/Development";
import Consulting from "../ServiceDetails/web3.0/Consulting";
import NFTmarketing from "../ServiceDetails/web3.0/NFTmarketing";
import NFTservice from "../ServiceDetails/web3.0/NFTservices";
import TokenLaunch from "../ServiceDetails/Crypto/TokenLaunch";
import Defi from "../ServiceDetails/web3.0/Defi";
import BSC from "../ServiceDetails/Crypto/BSC";
import IGO from "../ServiceDetails/Crypto/IGO";
import ICO from "../ServiceDetails/Crypto/ICO";
import TokenDevelopment from "../ServiceDetails/Crypto/TokenDevelopment";
import ILO from "../ServiceDetails/Crypto/ILO";
import ExchangeDevelopment from "../ServiceDetails/Exchange/ExchangeDevelopment";
import WhiteLabelExchange from "../ServiceDetails/Exchange/WhiteLabelExchange";
import WhiteLabelWallet from "../ServiceDetails/Exchange/WhiteLabelWallet";
import KycAmlServices from "../ServiceDetails/Exchange/KycAml";
import CentralizedCryptoExchangeDevelopment from "../ServiceDetails/Exchange/CentralizedExchange";
import HybridCryptoExchangeDevelopment from "../ServiceDetails/Exchange/HybridCryptoExchange";
import P2PCryptoExchangeDevelopment from "../ServiceDetails/Exchange/P2PCryptoExchange";
import CryptoListingService from "../ServiceDetails/Exchange/CryptoListing";
import DecentralizedCryptoExchangeDevelopment from "../ServiceDetails/Exchange/DecentralizedExchange";

import BlockchainDevelopment from "../ServiceDetails/Blockchain/BlockchainDevelopment";
import BlockchainConsulting from "../ServiceDetails/Blockchain/BlockchainConsulting";
import EcommerceBlockchainDevelopment from "../ServiceDetails/Blockchain/Ecommerce";
import Healthcare from "../ServiceDetails/Blockchain/Healthcare";
import Transportation from "../ServiceDetails/Blockchain/Transportation";
import Education from "../ServiceDetails/Blockchain/Education";
import SocialMedia from "../ServiceDetails/Blockchain/SocialMedia";
import SmartContractAudit from "../ServiceDetails/Blockchain/SmartContractAudit";
import RealEstate from "../ServiceDetails/Blockchain/RealEstate";
import Finance from "../ServiceDetails/Blockchain/Finance";
import Crypto from "../ServiceDetails/Blockchain/Crypto";
import Agriculture from "../ServiceDetails/Blockchain/Agriculture";
import Automobile from "../ServiceDetails/Blockchain/Automobile";
import NodeSalesService from "../ServiceDetails/Blockchain/NodeSaleServices";
import SolanaBlockchainDevelopment from "../ServiceDetails/Blockchain/SolanaBlockchain";
import CardanoBlockchainDevelopment from "../ServiceDetails/Blockchain/CardanoBlockchain";
import EthereumBlockchainDevelopment from "../ServiceDetails/Blockchain/EthereumBlockchain";
import Layer2BlockchainDevelopment from "../ServiceDetails/Blockchain/Layer2Blockchain";
import Layer2CryptocurrencyDevelopment from "../ServiceDetails/Blockchain/Layer2Cryptocurrency";
import SupplyChainBlockchainDevelopment from "../ServiceDetails/Blockchain/SupplyChainDevelopment";

import SmartContractDevelopment from "../ServiceDetails/Service/SmartContract";
import DAppDevelopment from "../ServiceDetails/Service/Dapps";
import DigitalMarketing from "../ServiceDetails/Service/DigitalMarketing";
import CryptocurrencyMarketingServices from "../ServiceDetails/Exchange/CryptoMarketing";

//blog detail page
import BlogDetail1 from "../BlogDetails/BlogDetail1";
import BlogDetail2 from "../BlogDetails/BlogDetail2";
import BlogDetail3 from "../BlogDetails/BlogDetail3";
import BlogDetail4 from "../BlogDetails/BlogDetail4";
import BlogDetail5 from "../BlogDetails/BlogDetail5";


import HireUs from "../HireUsPage/HireUs"

// ✅ Router Component
const AllRoute: React.FC = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <WowInit />
        <ScrollToTop />

        <Routes>
          {/* ✅ Home Routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/ai-marketing" element={<HomePage2 />} />
          <Route path="/ai-chatbot" element={<HomePage3 />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/service" element={<ServicePage />} />
          <Route path="/service-details" element={<SeviceSinglePage />} />
           
           {/* ✅ Service Detail Routes*/}
          <Route path="/business-consulting" element={<BusinessConsulting />} />
          <Route path="/web-development" element={<WebDevelopment />} />
          <Route path="/app-development" element={<AppDevelopment />} />
          <Route path="/brand-development" element={<BrandDevelopment />} />
          
          {/* Brand Development Mega Menu Routes */}
          <Route path="/logo-design" element={<LogoDesign />} />
          <Route path="/brand-identity" element={<BrandIdentity />} />
          <Route path="/ui-ux-design" element={<UIUXDesign />} />
          <Route path="/marketing-creatives" element={<MarketingCreatives />} />
          <Route path="/social-media-branding" element={<SocialMediaBranding />} />
          <Route path="/reputation-management" element={<ReputationManagement />} />
          
          {/* Web & App Development Mega Menu Routes */}
          <Route path="/website-portals" element={<WebsitePortals />} />
          <Route path="/saas-platforms" element={<SaasPlatforms />} />
          <Route path="/cms-development" element={<CMSDevelopment />} />
          <Route path="/ecommerce-platforms" element={<EcommercePlatforms />} />
          <Route path="/android-apps" element={<AndroidApps />} />
          <Route path="/ios-apps" element={<IOSApps />} />
          <Route path="/hybrid-apps" element={<HybridApps />} />
          <Route path="/web3-apps" element={<Web3Apps />} />
          <Route path="/on-demand-apps" element={<OnDemandApps />} />
          <Route path="/enterprise-apps" element={<EnterpriseApps />} />
          <Route path="/crypto-exchange-service" element={<CryptoExchangeService />} />
          <Route path="/nft-marketplace-service" element={<NftMarketplace />} />
          <Route path="/development" element={<Development />} />
          <Route path="/consulting" element={<Consulting />} />
          <Route path="/nft-marketing" element={<NFTmarketing />} />
          <Route path="/nft-service" element={<NFTservice />} />
          <Route path="/token-launch" element={<TokenLaunch />} />
          <Route path="/defi" element={<Defi />} />
          <Route path="/bsc-development" element={<BSC />} />
          <Route path="/igo" element={<IGO />} />
          <Route path="/ico" element={<ICO />} />
          <Route path="/token-development" element={<TokenDevelopment />} />
          <Route path="/ilo" element={<ILO />} />
          <Route path="/exchange-development" element={<ExchangeDevelopment />} />
          <Route path="/white-label-exchange" element={<WhiteLabelExchange />} />
          <Route path="/white-label-wallet" element={<WhiteLabelWallet />} />
          <Route path="/kyc-aml-services" element={<KycAmlServices />} />
          <Route path="/centralized-crypto-exchange-development" element={<CentralizedCryptoExchangeDevelopment />} />
          <Route path="/hybrid-crypto-exchange-development" element={<HybridCryptoExchangeDevelopment />} />
          <Route path="/p2p-crypto-exchange-development" element={<P2PCryptoExchangeDevelopment />} />
          <Route path="/crypto-listing-service" element={<CryptoListingService />} />
          <Route path="/decentralized-crypto-exchange-development" element={<DecentralizedCryptoExchangeDevelopment />} />
          <Route path="/blockchain-development" element={<BlockchainDevelopment />} />
          <Route path="/blockchain-consulting" element={<BlockchainConsulting />} />
          <Route path="/ecommerce-blockchain-development" element={<EcommerceBlockchainDevelopment />} />
          <Route path="/healthcare-blockchain-development" element={<Healthcare />} />
          <Route path="/transportation-blockchain-development" element={<Transportation />} />
          <Route path="/education-blockchain-development" element={<Education />} />
          <Route path="/social-media-blockchain-development" element={<SocialMedia />} />
          <Route path="/smart-contract-audit" element={<SmartContractAudit />} />
          <Route path="/real-estate-blockchain-development" element={<RealEstate />} />
          <Route path="/finance-blockchain-development" element={<Finance />} />
          <Route path="/crypto-blockchain-development" element={<Crypto />} />
          <Route path="/agriculture-blockchain-development" element={<Agriculture />} />
          <Route path="/automobile-blockchain-development" element={<Automobile />} />
          <Route path="/node-sale-services" element={<NodeSalesService />} />
          <Route path="/solana-blockchain-development" element={<SolanaBlockchainDevelopment />} />
          <Route path="/cardano-blockchain-development" element={<CardanoBlockchainDevelopment />} />
          <Route path="/ethereum-blockchain-development" element={<EthereumBlockchainDevelopment />} />
          <Route path="/layer2-blockchain-development" element={<Layer2BlockchainDevelopment />} />
          <Route path="/layer2-cryptocurrency-development" element={<Layer2CryptocurrencyDevelopment />} />
          <Route path="/supply-chain-blockchain-development" element={<SupplyChainBlockchainDevelopment />} />
          <Route path="/smart-contract-development" element={<SmartContractDevelopment />} />
          <Route path="/dapp-development" element={<DAppDevelopment />} />
          <Route path="/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/cryptocurrency-marketing-services" element={<CryptocurrencyMarketingServices />} />

          <Route path="/Explore Our Smart AI Solutions in Blockchain for the Future of Business" element={<BlogDetail1/>}/>
          <Route path="/How Businesses Are Using Blockchain Technology to Reduce Costs & Increase Trust" element={<BlogDetail2/>}/>
          <Route path="/How to Build an NFT Marketplace: Features, Cost & Development Process" element={<BlogDetail3/>}/>
          <Route path="/Centralized vs Decentralized Crypto Exchanges: Which One Should You Build?" element={<BlogDetail4/>}/>
          <Route path="/Crypto-Powered Marketing: Smarter Campaigns, Better ROI" element={<BlogDetail5/>}/>
          
          

          <Route path="/career" element={<CareerSection />} />
          <Route path="/career-details" element={<CareerDetails />} />
          <Route path="/project" element={<ProjectPage />} />
          <Route path="/hire-us" element={<HireUs/>}/>

          <Route path="/web3.0-menu-page" element={<MegaPage3/>}/>
          <Route path="/crypto-menu-page" element={<MegaPage4/>}/>
          <Route path="/exchange-menu-page" element={<MegaPage5/>}/>
          <Route path="/blockchain-menu-page" element={<MegaPage6/>}/>
          <Route path="/service-menu-page" element={<MegaPage7/>}/>



          <Route path="/project-details" element={<ProjectDetails />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog-details" element={<BlogDetails />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* ✅ Error Page */}
          <Route path="/404" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
